module.exports = __webpack_public_path__ + "static/media/mail-icon.d25a3e6e.svg";